import * as ambassadorWixDataSyncV1Jobs from './data-sync-v1-jobs-data-sync-jobs.http.js';
import * as ambassadorWixDataSyncV1JobsTypes from './data-sync-v1-jobs-data-sync-jobs.types.js';
import * as ambassadorWixDataSyncV1JobsUniversalTypes from './data-sync-v1-jobs-data-sync-jobs.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createScheduledDataWorkflow(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataSyncV1JobsUniversalTypes.CreateScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsTypes.CreateScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsUniversalTypes.CreateScheduledDataWorkflowResponse,
  ambassadorWixDataSyncV1JobsTypes.CreateScheduledDataWorkflowResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataSyncV1Jobs.createScheduledDataWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/scheduled-data-workflows',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rescheduleScheduledDataWorkflow(): __PublicMethodMetaInfo<
  'POST',
  { scheduledDataWorkflowId: string },
  ambassadorWixDataSyncV1JobsUniversalTypes.RescheduleScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsTypes.RescheduleScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsUniversalTypes.RescheduleScheduledDataWorkflowResponse,
  ambassadorWixDataSyncV1JobsTypes.RescheduleScheduledDataWorkflowResponse
> {
  const payload = {
    scheduledDataWorkflowId: ':scheduledDataWorkflowId',
  } as any;

  const getRequestOptions =
    ambassadorWixDataSyncV1Jobs.rescheduleScheduledDataWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/scheduled-data-workflows/{scheduledDataWorkflowId}/reschedule',
    pathParams: { scheduledDataWorkflowId: 'scheduledDataWorkflowId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function triggerScheduledDataWorkflowNow(): __PublicMethodMetaInfo<
  'POST',
  { scheduledDataWorkflowId: string },
  ambassadorWixDataSyncV1JobsUniversalTypes.TriggerScheduledDataWorkflowNowRequest,
  ambassadorWixDataSyncV1JobsTypes.TriggerScheduledDataWorkflowNowRequest,
  ambassadorWixDataSyncV1JobsUniversalTypes.TriggerScheduledDataWorkflowNowResponse,
  ambassadorWixDataSyncV1JobsTypes.TriggerScheduledDataWorkflowNowResponse
> {
  const payload = {
    scheduledDataWorkflowId: ':scheduledDataWorkflowId',
  } as any;

  const getRequestOptions =
    ambassadorWixDataSyncV1Jobs.triggerScheduledDataWorkflowNow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/scheduled-data-workflows/{scheduledDataWorkflowId}/run-now',
    pathParams: { scheduledDataWorkflowId: 'scheduledDataWorkflowId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateScheduledDataWorkflow(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixDataSyncV1JobsUniversalTypes.UpdateScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsTypes.UpdateScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsUniversalTypes.UpdateScheduledDataWorkflowResponse,
  ambassadorWixDataSyncV1JobsTypes.UpdateScheduledDataWorkflowResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataSyncV1Jobs.updateScheduledDataWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/scheduled-data-workflows',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteScheduledDataWorkflow(): __PublicMethodMetaInfo<
  'DELETE',
  { scheduledDataWorkflowId: string },
  ambassadorWixDataSyncV1JobsUniversalTypes.DeleteScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsTypes.DeleteScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsUniversalTypes.DeleteScheduledDataWorkflowResponse,
  ambassadorWixDataSyncV1JobsTypes.DeleteScheduledDataWorkflowResponse
> {
  const payload = {
    scheduledDataWorkflowId: ':scheduledDataWorkflowId',
  } as any;

  const getRequestOptions =
    ambassadorWixDataSyncV1Jobs.deleteScheduledDataWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/scheduled-data-workflows/{scheduledDataWorkflowId}',
    pathParams: { scheduledDataWorkflowId: 'scheduledDataWorkflowId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getScheduledDataWorkflow(): __PublicMethodMetaInfo<
  'GET',
  { scheduledDataWorkflowId: string },
  ambassadorWixDataSyncV1JobsUniversalTypes.GetScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsTypes.GetScheduledDataWorkflowRequest,
  ambassadorWixDataSyncV1JobsUniversalTypes.GetScheduledDataWorkflowResponse,
  ambassadorWixDataSyncV1JobsTypes.GetScheduledDataWorkflowResponse
> {
  const payload = {
    scheduledDataWorkflowId: ':scheduledDataWorkflowId',
  } as any;

  const getRequestOptions =
    ambassadorWixDataSyncV1Jobs.getScheduledDataWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/scheduled-data-workflows/{scheduledDataWorkflowId}',
    pathParams: { scheduledDataWorkflowId: 'scheduledDataWorkflowId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listScheduledDataWorkflows(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataSyncV1JobsUniversalTypes.ListScheduledDataWorkflowsRequest,
  ambassadorWixDataSyncV1JobsTypes.ListScheduledDataWorkflowsRequest,
  ambassadorWixDataSyncV1JobsUniversalTypes.ListScheduledDataWorkflowsResponse,
  ambassadorWixDataSyncV1JobsTypes.ListScheduledDataWorkflowsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataSyncV1Jobs.listScheduledDataWorkflows(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/scheduled-data-workflows',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ScheduledDataWorkflow as ScheduledDataWorkflowOriginal,
  ScheduledDataWorkflowSpec as ScheduledDataWorkflowSpecOriginal,
  JobSpec as JobSpecOriginal,
  JobSpecSiteOverrideOneOf as JobSpecSiteOverrideOneOfOriginal,
  Source as SourceOriginal,
  SourceSourceOneOf as SourceSourceOneOfOriginal,
  WixDataEnvironment as WixDataEnvironmentOriginal,
  WixDataEnvironmentWithLiterals as WixDataEnvironmentWithLiteralsOriginal,
  FileFormat as FileFormatOriginal,
  FileFormatWithLiterals as FileFormatWithLiteralsOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  WixDataSource as WixDataSourceOriginal,
  LocalizationSource as LocalizationSourceOriginal,
  FileSource as FileSourceOriginal,
  TestSource as TestSourceOriginal,
  DataMovementJobLogs as DataMovementJobLogsOriginal,
  ExternalFileSource as ExternalFileSourceOriginal,
  GoogleSheetsSource as GoogleSheetsSourceOriginal,
  WixMediaSource as WixMediaSourceOriginal,
  WixDataCollectionDefinitionSource as WixDataCollectionDefinitionSourceOriginal,
  Destination as DestinationOriginal,
  DestinationDestinationOneOf as DestinationDestinationOneOfOriginal,
  WixDataDestination as WixDataDestinationOriginal,
  WixDataDestinationWritePolicy as WixDataDestinationWritePolicyOriginal,
  WixDataDestinationWritePolicyWithLiterals as WixDataDestinationWritePolicyWithLiteralsOriginal,
  LocalizationDestination as LocalizationDestinationOriginal,
  FileDestination as FileDestinationOriginal,
  Schema as SchemaOriginal,
  Field as FieldOriginal,
  FieldType as FieldTypeOriginal,
  FieldTypeWithLiterals as FieldTypeWithLiteralsOriginal,
  StoresCatalogProductsDestination as StoresCatalogProductsDestinationOriginal,
  WixMediaDestination as WixMediaDestinationOriginal,
  WixMediaDestinationWritePolicy as WixMediaDestinationWritePolicyOriginal,
  WixMediaDestinationWritePolicyWithLiterals as WixMediaDestinationWritePolicyWithLiteralsOriginal,
  WixDataCollectionDefinitionDestination as WixDataCollectionDefinitionDestinationOriginal,
  WritePolicy as WritePolicyOriginal,
  WritePolicyWithLiterals as WritePolicyWithLiteralsOriginal,
  StoresCatalogInventoryDestination as StoresCatalogInventoryDestinationOriginal,
  TestDestination as TestDestinationOriginal,
  Transformation as TransformationOriginal,
  TransformationTransformationOneOf as TransformationTransformationOneOfOriginal,
  TestTransformation as TestTransformationOriginal,
  CreateScheduledDataWorkflowRequest as CreateScheduledDataWorkflowRequestOriginal,
  Fields as FieldsOriginal,
  FieldsWithLiterals as FieldsWithLiteralsOriginal,
  CreateScheduledDataWorkflowResponse as CreateScheduledDataWorkflowResponseOriginal,
  RescheduleScheduledDataWorkflowRequest as RescheduleScheduledDataWorkflowRequestOriginal,
  RescheduleScheduledDataWorkflowResponse as RescheduleScheduledDataWorkflowResponseOriginal,
  TriggerScheduledDataWorkflowNowRequest as TriggerScheduledDataWorkflowNowRequestOriginal,
  TriggerScheduledDataWorkflowNowResponse as TriggerScheduledDataWorkflowNowResponseOriginal,
  UpdateScheduledDataWorkflowRequest as UpdateScheduledDataWorkflowRequestOriginal,
  UpdateScheduledDataWorkflowResponse as UpdateScheduledDataWorkflowResponseOriginal,
  DeleteScheduledDataWorkflowRequest as DeleteScheduledDataWorkflowRequestOriginal,
  DeleteScheduledDataWorkflowResponse as DeleteScheduledDataWorkflowResponseOriginal,
  GetScheduledDataWorkflowRequest as GetScheduledDataWorkflowRequestOriginal,
  GetScheduledDataWorkflowResponse as GetScheduledDataWorkflowResponseOriginal,
  ListScheduledDataWorkflowsRequest as ListScheduledDataWorkflowsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListScheduledDataWorkflowsResponse as ListScheduledDataWorkflowsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './data-sync-v1-jobs-data-sync-jobs.types.js';
